import React from 'react';
import {
  TextField,
  Select,
  MenuItem,
  Button,
  Typography,
  InputLabel,
  FormControl,
  Checkbox,
  FormControlLabel
} from '@mui/material';

// Editor para campos condicionales anidados (dentro de un dropbox condicional)
const NestedConditionalFieldEditor = ({
  nestedField,
  nestedFieldIndex,
  id,
  optionIndex,
  fieldIndex,
  nestedOptionIndex,
  handleNestedConditionalFieldChange,
  handleRemoveNestedConditionalField,
  handleAddNestedConditionalDropboxOption,
  handleRemoveNestedConditionalDropboxOption,
  handleNestedConditionalDropboxOptionChange
}) => (
  <div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '10px',
    padding: '8px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    border: '1px solid #e0e0e0'
  }}>
    <TextField
      size="small"
      placeholder="Nombre del campo"
      value={nestedField.title || ''}
      onChange={(e) => handleNestedConditionalFieldChange(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex, 'title', e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{ minWidth: '150px' }}
    />
    <FormControl size="small" style={{ minWidth: '150px' }}>
      <InputLabel>Tipo</InputLabel>
      <Select
        value={nestedField.type || 'TEXT'}
        label="Tipo"
        onChange={(e) => handleNestedConditionalFieldChange(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex, 'type', e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem value="TEXT">Texto</MenuItem>
        <MenuItem value="NUMBER">Número</MenuItem>
        <MenuItem value="DATE">Fecha</MenuItem>
        <MenuItem value="DATE_TIME">Fecha y hora</MenuItem>
        <MenuItem value="EMAIL">Correo electrónico</MenuItem>
        <MenuItem value="URL">URL</MenuItem>
        <MenuItem value="UPLOAD">Fotografía</MenuItem>
        <MenuItem value="UPLOAD_FILE">Adjuntar archivos</MenuItem>
        <MenuItem value="SIGNATURE">Firma</MenuItem>
        <MenuItem value="DROPBOX">Opción (dropbox)</MenuItem>
      </Select>
    </FormControl>
    <FormControlLabel
      control={
        <Checkbox
          checked={nestedField.required !== false}
          onChange={(e) => handleNestedConditionalFieldChange(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex, 'required', e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      }
      label="Requerido"
    />
    <Button
      type="button"
      variant="outlined"
      color="error"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveNestedConditionalField(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex);
      }}
    >
      ✕
    </Button>
    {nestedField.type === 'DROPBOX' && (
      <div style={{ width: '100%', marginTop: '8px', paddingLeft: '10px' }}>
        <Typography variant="caption">Opciones del dropbox:</Typography>
        {(nestedField.dropbox || []).map((dropOpt, dropOptIndex) => (
          <div key={dropOptIndex} style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
            <TextField
              size="small"
              value={dropOpt || ''}
              placeholder={`Opción ${dropOptIndex + 1}`}
              onChange={(e) => handleNestedConditionalDropboxOptionChange(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex, dropOptIndex, e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <Button
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveNestedConditionalDropboxOption(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex, dropOptIndex);
              }}
            >
              ✕
            </Button>
          </div>
        ))}
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAddNestedConditionalDropboxOption(id, optionIndex, fieldIndex, nestedOptionIndex, nestedFieldIndex);
          }}
          style={{ marginTop: '4px' }}
        >
          + Opción
        </Button>
      </div>
    )}
  </div>
);

const ConditionalFieldEditor = ({
  condField,
  fieldIndex,
  id,
  optionIndex,
  handleConditionalFieldChange,
  handleRemoveConditionalField,
  handleAddConditionalDropboxOption,
  handleRemoveConditionalDropboxOption,
  handleConditionalDropboxOptionChange,
  handleAddNestedConditionalField,
  handleRemoveNestedConditionalField,
  handleNestedConditionalFieldChange,
  handleAddNestedConditionalDropboxOption,
  handleRemoveNestedConditionalDropboxOption,
  handleNestedConditionalDropboxOptionChange,
  onConditionalRepeatableSectionFieldAdd,
  onConditionalRepeatableSectionFieldRemove,
  onConditionalRepeatableSectionFieldChange,
  onConditionalRepeatableSectionDropboxOptionAdd,
  onConditionalRepeatableSectionDropboxOptionRemove,
  onConditionalRepeatableSectionDropboxOptionChange,
  onConditionalRepeatableSectionUpdate
}) => (
  <div style={{
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '10px',
    padding: '8px',
    backgroundColor: 'white',
    borderRadius: '4px',
    border: '1px solid #bbdefb'
  }}>
    <TextField
      size="small"
      placeholder="Nombre del campo"
      value={condField.title || ''}
      onChange={(e) => handleConditionalFieldChange(id, optionIndex, fieldIndex, 'title', e.target.value)}
      onClick={(e) => e.stopPropagation()}
      style={{ minWidth: '150px' }}
    />
    <FormControl size="small" style={{ minWidth: '150px' }}>
      <InputLabel>Tipo</InputLabel>
      <Select
        value={condField.type || 'TEXT'}
        label="Tipo"
        onChange={(e) => handleConditionalFieldChange(id, optionIndex, fieldIndex, 'type', e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        <MenuItem value="TEXT">Texto</MenuItem>
        <MenuItem value="NUMBER">Número</MenuItem>
        <MenuItem value="DATE">Fecha</MenuItem>
        <MenuItem value="DATE_TIME">Fecha y hora</MenuItem>
        <MenuItem value="EMAIL">Correo electrónico</MenuItem>
        <MenuItem value="URL">URL</MenuItem>
        <MenuItem value="UPLOAD">Fotografía</MenuItem>
        <MenuItem value="UPLOAD_FILE">Adjuntar archivos</MenuItem>
        <MenuItem value="SIGNATURE">Firma</MenuItem>
        <MenuItem value="DROPBOX">Opción (dropbox)</MenuItem>
        <MenuItem value="REPEATABLE_SECTION">Sección repetible</MenuItem>
      </Select>
    </FormControl>
    <FormControlLabel
      control={
        <Checkbox
          checked={condField.required !== false}
          onChange={(e) => handleConditionalFieldChange(id, optionIndex, fieldIndex, 'required', e.target.checked)}
          onClick={(e) => e.stopPropagation()}
          size="small"
        />
      }
      label="Requerido"
    />
    <Button
      type="button"
      variant="outlined"
      color="error"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        handleRemoveConditionalField(id, optionIndex, fieldIndex);
      }}
    >
      ✕
    </Button>

    {/* Opciones para dropbox condicional */}
    {condField.type === 'DROPBOX' && (
      <div style={{ width: '100%', marginTop: '8px', paddingLeft: '10px' }}>
        <Typography variant="caption">Opciones del dropbox:</Typography>
        {(condField.dropbox || []).map((dropOpt, dropOptIndex) => (
          <div key={dropOptIndex} style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
            <TextField
              size="small"
              value={dropOpt || ''}
              placeholder={`Opción ${dropOptIndex + 1}`}
              onChange={(e) => handleConditionalDropboxOptionChange(id, optionIndex, fieldIndex, dropOptIndex, e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
            <Button
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                handleRemoveConditionalDropboxOption(id, optionIndex, fieldIndex, dropOptIndex);
              }}
            >
              ✕
            </Button>
          </div>
        ))}
        <Button
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleAddConditionalDropboxOption(id, optionIndex, fieldIndex);
          }}
          style={{ marginTop: '4px' }}
        >
          + Opción
        </Button>

        {/* Campos condicionales anidados (por cada opción del dropbox condicional) */}
        {(condField.dropbox || []).map((nestedOptLabel, nestedOptionIndex) => (
          <div key={nestedOptionIndex} style={{ width: '100%', marginTop: '12px', padding: '10px', borderRadius: '6px', border: '1px dashed #90caf9', backgroundColor: '#e3f2fd' }}>
            <Typography variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px', color: '#1565c0' }}>
              📋 Campos condicionales (al seleccionar "{nestedOptLabel || `Opción ${nestedOptionIndex + 1}`}")
            </Typography>
            {(condField.conditionalFields && condField.conditionalFields[nestedOptionIndex] && condField.conditionalFields[nestedOptionIndex].length > 0) && (
              condField.conditionalFields[nestedOptionIndex].map((nestedField, nestedFieldIndex) => (
                <NestedConditionalFieldEditor
                  key={nestedFieldIndex}
                  nestedField={nestedField}
                  nestedFieldIndex={nestedFieldIndex}
                  id={id}
                  optionIndex={optionIndex}
                  fieldIndex={fieldIndex}
                  nestedOptionIndex={nestedOptionIndex}
                  handleNestedConditionalFieldChange={handleNestedConditionalFieldChange}
                  handleRemoveNestedConditionalField={handleRemoveNestedConditionalField}
                  handleAddNestedConditionalDropboxOption={handleAddNestedConditionalDropboxOption}
                  handleRemoveNestedConditionalDropboxOption={handleRemoveNestedConditionalDropboxOption}
                  handleNestedConditionalDropboxOptionChange={handleNestedConditionalDropboxOptionChange}
                />
              ))
            )}
            <Button
              type="button"
              variant="outlined"
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleAddNestedConditionalField(id, optionIndex, fieldIndex, nestedOptionIndex);
              }}
              style={{ borderStyle: 'dashed', marginTop: '4px' }}
            >
              + Añadir campo condicional
            </Button>
          </div>
        ))}
      </div>
    )}

    {/* Sección repetible condicional */}
    {condField.type === 'REPEATABLE_SECTION' && onConditionalRepeatableSectionFieldAdd && (
      <div style={{ width: '100%', marginTop: '10px', padding: '10px', borderRadius: '6px', border: '1px solid #e0e0e0', backgroundColor: '#fafafa' }}>
        <Typography variant="caption" style={{ fontWeight: 'bold', display: 'block', marginBottom: '8px' }}>
          Campos de la sección repetible
        </Typography>
        {(condField.sectionFields || []).map((sectionField, sectionFieldIndex) => (
          <div
            key={sectionFieldIndex}
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'wrap',
              alignItems: 'center',
              marginBottom: '8px',
              padding: '8px',
              backgroundColor: 'white',
              borderRadius: '4px',
              border: '1px solid #e0e0e0'
            }}
          >
            <TextField
              size="small"
              placeholder="Nombre del campo"
              value={sectionField.title || ''}
              onChange={(e) => onConditionalRepeatableSectionFieldChange(id, optionIndex, fieldIndex, sectionFieldIndex, 'title', e.target.value)}
              onClick={(e) => e.stopPropagation()}
              style={{ minWidth: '120px' }}
            />
            <FormControl size="small" style={{ minWidth: '120px' }}>
              <InputLabel>Tipo</InputLabel>
              <Select
                value={sectionField.type || 'TEXT'}
                label="Tipo"
                onChange={(e) => onConditionalRepeatableSectionFieldChange(id, optionIndex, fieldIndex, sectionFieldIndex, 'type', e.target.value)}
                onClick={(e) => e.stopPropagation()}
              >
                <MenuItem value="TEXT">Texto</MenuItem>
                <MenuItem value="NUMBER">Número</MenuItem>
                <MenuItem value="DATE">Fecha</MenuItem>
                <MenuItem value="DATE_TIME">Fecha y hora</MenuItem>
                <MenuItem value="EMAIL">Correo electrónico</MenuItem>
                <MenuItem value="URL">URL</MenuItem>
                <MenuItem value="UPLOAD">Fotografía</MenuItem>
                <MenuItem value="UPLOAD_FILE">Adjuntar archivos</MenuItem>
                <MenuItem value="SIGNATURE">Firma</MenuItem>
                <MenuItem value="DROPBOX">Opción (dropbox)</MenuItem>
              </Select>
            </FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sectionField.required !== false}
                  onChange={(e) => onConditionalRepeatableSectionFieldChange(id, optionIndex, fieldIndex, sectionFieldIndex, 'required', e.target.checked)}
                  onClick={(e) => e.stopPropagation()}
                  size="small"
                />
              }
              label="Req."
            />
            <Button
              size="small"
              color="error"
              onClick={(e) => {
                e.stopPropagation();
                onConditionalRepeatableSectionFieldRemove(id, optionIndex, fieldIndex, sectionFieldIndex);
              }}
            >
              ✕
            </Button>
            {sectionField.type === 'DROPBOX' && (
              <div style={{ width: '100%', marginTop: '4px', paddingLeft: '8px' }}>
                <Typography variant="caption">Opciones:</Typography>
                {(sectionField.dropbox || []).map((dropOpt, dropOptIndex) => (
                  <div key={dropOptIndex} style={{ display: 'flex', gap: '4px', marginTop: '2px' }}>
                    <TextField
                      size="small"
                      value={dropOpt || ''}
                      placeholder={`Opción ${dropOptIndex + 1}`}
                      onChange={(e) => onConditionalRepeatableSectionDropboxOptionChange(id, optionIndex, fieldIndex, sectionFieldIndex, dropOptIndex, e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <Button
                      size="small"
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation();
                        onConditionalRepeatableSectionDropboxOptionRemove(id, optionIndex, fieldIndex, sectionFieldIndex, dropOptIndex);
                      }}
                    >
                      ✕
                    </Button>
                  </div>
                ))}
                <Button
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onConditionalRepeatableSectionDropboxOptionAdd(id, optionIndex, fieldIndex, sectionFieldIndex);
                  }}
                  style={{ marginTop: '4px' }}
                >
                  + Opción
                </Button>
              </div>
            )}
          </div>
        ))}
        <Button
          size="small"
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            onConditionalRepeatableSectionFieldAdd(id, optionIndex, fieldIndex);
          }}
          style={{ borderStyle: 'dashed', marginBottom: '8px' }}
        >
          + Añadir campo a la sección
        </Button>
        <div style={{ display: 'flex', gap: '10px', marginTop: '8px' }}>
          <TextField
            size="small"
            type="number"
            label="Mín. instancias"
            value={condField.minInstances ?? 1}
            onChange={(e) => onConditionalRepeatableSectionUpdate(id, optionIndex, fieldIndex, { minInstances: parseInt(e.target.value) || 1 })}
            onClick={(e) => e.stopPropagation()}
            inputProps={{ min: 1 }}
            style={{ width: '120px' }}
          />
          <TextField
            size="small"
            type="number"
            label="Máx. instancias"
            value={condField.maxInstances ?? 10}
            onChange={(e) => onConditionalRepeatableSectionUpdate(id, optionIndex, fieldIndex, { maxInstances: parseInt(e.target.value) || 10 })}
            onClick={(e) => e.stopPropagation()}
            inputProps={{ min: 1 }}
            style={{ width: '120px' }}
          />
        </div>
      </div>
    )}
  </div>
);

const DropboxOptions = ({
  id,
  input,
  handleOptionChange,
  handleRemoveOption,
  handleAddOption,
  handleAddConditionalField,
  handleRemoveConditionalField,
  handleConditionalFieldChange,
  handleAddConditionalDropboxOption,
  handleRemoveConditionalDropboxOption,
  handleConditionalDropboxOptionChange,
  handleAddNestedConditionalField,
  handleRemoveNestedConditionalField,
  handleNestedConditionalFieldChange,
  handleAddNestedConditionalDropboxOption,
  handleRemoveNestedConditionalDropboxOption,
  handleNestedConditionalDropboxOptionChange,
  handleConditionalRepeatableSectionFieldAdd,
  handleConditionalRepeatableSectionFieldRemove,
  handleConditionalRepeatableSectionFieldChange,
  handleConditionalRepeatableSectionDropboxOptionAdd,
  handleConditionalRepeatableSectionDropboxOptionRemove,
  handleConditionalRepeatableSectionDropboxOptionChange,
  handleConditionalRepeatableSectionUpdate
}) => {
  return (
    <div>
      <Typography>Opciones:</Typography>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {input.dropbox &&
          input.dropbox.map((option, optionIndex) => (
            <li key={optionIndex} style={{
              marginBottom: '15px',
              padding: '10px',
              backgroundColor: '#f9f9f9',
              borderRadius: '6px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                <TextField
                  type="text"
                  value={option || ''}
                  onChange={(e) => handleOptionChange(id, optionIndex, e.target.value)}
                  className="input-field"
                  onClick={(e) => e.stopPropagation()}
                  size="small"
                  placeholder={`Opción ${optionIndex + 1}`}
                />
                <Button
                  type="button"
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveOption(id, optionIndex);
                  }}
                >
                  Eliminar
                </Button>
              </div>

              {/* Campos condicionales */}
              <div style={{ marginLeft: '20px', marginTop: '8px' }}>
                {input.conditionalFields && input.conditionalFields[optionIndex] && input.conditionalFields[optionIndex].length > 0 && (
                  <div style={{
                    padding: '10px',
                    backgroundColor: '#e8f4fd',
                    borderRadius: '4px',
                    border: '1px dashed #2196f3',
                    marginBottom: '8px'
                  }}>
                    <Typography variant="caption" style={{ color: '#1976d2', fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                      📋 Campos condicionales (aparecen al seleccionar "{option || `Opción ${optionIndex + 1}`}")
                    </Typography>

                    {input.conditionalFields[optionIndex].map((condField, fieldIndex) => (
                      <ConditionalFieldEditor
                        key={fieldIndex}
                        condField={condField}
                        fieldIndex={fieldIndex}
                        id={id}
                        optionIndex={optionIndex}
                        handleConditionalFieldChange={handleConditionalFieldChange}
                        handleRemoveConditionalField={handleRemoveConditionalField}
                        handleAddConditionalDropboxOption={handleAddConditionalDropboxOption}
                        handleRemoveConditionalDropboxOption={handleRemoveConditionalDropboxOption}
                        handleConditionalDropboxOptionChange={handleConditionalDropboxOptionChange}
                        handleAddNestedConditionalField={handleAddNestedConditionalField}
                        handleRemoveNestedConditionalField={handleRemoveNestedConditionalField}
                        handleNestedConditionalFieldChange={handleNestedConditionalFieldChange}
                        handleAddNestedConditionalDropboxOption={handleAddNestedConditionalDropboxOption}
                        handleRemoveNestedConditionalDropboxOption={handleRemoveNestedConditionalDropboxOption}
                        handleNestedConditionalDropboxOptionChange={handleNestedConditionalDropboxOptionChange}
                        onConditionalRepeatableSectionFieldAdd={handleConditionalRepeatableSectionFieldAdd}
                        onConditionalRepeatableSectionFieldRemove={handleConditionalRepeatableSectionFieldRemove}
                        onConditionalRepeatableSectionFieldChange={handleConditionalRepeatableSectionFieldChange}
                        onConditionalRepeatableSectionDropboxOptionAdd={handleConditionalRepeatableSectionDropboxOptionAdd}
                        onConditionalRepeatableSectionDropboxOptionRemove={handleConditionalRepeatableSectionDropboxOptionRemove}
                        onConditionalRepeatableSectionDropboxOptionChange={handleConditionalRepeatableSectionDropboxOptionChange}
                        onConditionalRepeatableSectionUpdate={handleConditionalRepeatableSectionUpdate}
                      />
                    ))}
                  </div>
                )}

                <Button
                  type="button"
                  variant="outlined"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddConditionalField(id, optionIndex);
                  }}
                  style={{ borderStyle: 'dashed' }}
                >
                  + Añadir campo condicional
                </Button>
              </div>
            </li>
          ))}
      </ul>
      <Button
        type="button"
        variant="contained"
        color="success"
        onClick={(e) => {
          e.stopPropagation();
          handleAddOption(id);
        }}
      >
        Agregar Opción
      </Button>
    </div>
  );
};

export default DropboxOptions;
